export type ChildGender = 'hijo' | 'hija' | ''

export interface PersonalizationProfile {
  parent_name: string
  purchase_email: string
  child_name: string
  child_gender: ChildGender
  child_age: string
  child_interests: string[]
  child_personality: string[]
  development_priorities: string[]
  challenging_situations: string[]
  parent_context: string
  special_detail: string
  parent_message: string
  parental_consent: boolean
}

export interface SubmittedProfile extends PersonalizationProfile {
  submitted_at: string
  status: 'profile_received'
}

export const emptyProfile: PersonalizationProfile = {
  parent_name: '',
  purchase_email: '',
  child_name: '',
  child_gender: '',
  child_age: '',
  child_interests: [],
  child_personality: [],
  development_priorities: [],
  challenging_situations: [],
  parent_context: '',
  special_detail: '',
  parent_message: '',
  parental_consent: false,
}
